import React, { ReactNode } from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import "../../styles/layout.scss"
import "bootstrap/dist/css/bootstrap.min.css"

import styled from "styled-components"
import Header from "./Header"
import Container from "react-bootstrap/Container"
import media from "../../helpers/media"
import Title from "./Title"

interface IMainWrapper {
  id?: string
}

const MainWrapper = styled.div<IMainWrapper>`
  overflow: ${({ id }: IMainWrapper): string =>
    id ? "hidden" : "initial"};

  #navigation {
    ${({ id }: IMainWrapper): string =>
      id
        ? ""
        : ` 
        position: fixed;
        width: 100%;
        z-index: 100;
      `};
  }

  #content-wrapper {
    ${({ id }: IMainWrapper): string =>
      id
        ? ""
        : ` 
        padding-top: 50px;
      `};
  }
`

interface IContainer {
  fluid?: boolean
  as?: string
  mobileFluid?: boolean
}
const StyledContainer = styled(Container)<IContainer>`
  padding-right: 20px;
  padding-left: 20px;

  ${media.tablet} {
    padding-right: 30px;
    padding-left: 30px;

    ${({ mobileFluid }) => mobileFluid && `padding: 0 15px;`}
  }

  ${media.laptop} {
    ${({ mobileFluid }) => mobileFluid && `padding: 0;`}
  }
`

const Content = styled.div`
  margin: 0 auto;
  /* min-height: 95vh; */
  height: calc(100vh - 50px);
`

const Footer = styled.footer`
  margin: 25px auto 0 auto;
`

const getData = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
        logo
      }
    }
  }
`

interface IProps {
  children: ReactNode
  id?: string
  title?: string | JSX.Element
  container?: "default" | "fluid" | "mobileFluid"
}

const Layout = ({ id, children, title, container }: IProps) => {
  const data = useStaticQuery(getData)

  return (
    <MainWrapper id={id}>
      <Header siteTitle={data.site.siteMetadata.logo} />
      <Content id="content-wrapper">
        {(container === "fluid" || container === "mobileFluid") && (
          <StyledContainer
            fluid
            as="main"
            mobileFluid={container === "mobileFluid"}
          >
            {title && <Title content={title} />}
            {children}
          </StyledContainer>
        )}

        {container === "default" && (
          <StyledContainer as="main">
            {title && <Title content={title} />}
            {children}
          </StyledContainer>
        )}

        {!container && (
          <main>
            {title && <Title content={title} />}
            {children}
          </main>
        )}
      </Content>
    </MainWrapper>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
